import React, { Component, ErrorInfo, ReactElement } from "react";
import { UIErrorState } from "@preveil-api";
import ErrorComponent from "./ErrorComponent.component";

type AllProps = {
  children?: ReactElement;
};

class ErrorBoundaryComponent extends Component<AllProps, UIErrorState> {
  constructor(props: AllProps) {
    super(props);
    this.state = {
      hasError: false,
      error: { name: "", message: "", stack: "" },
      error_info: { componentStack: "" }
    };
  }

  resetState() {
    this.setState({
      hasError: false,
      error: { name: "", message: "", stack: "" },
      error_info: { componentStack: "" }
    });
  }

  static getDerivedStateFromError = (error: Error) => {
    return {
      hasError: true,
      error
    };
  };

  // WORKING ON THIS
  componentDidCatch(error: Error, error_info: ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      error_info
    });
  }

  render() {
    const { error, error_info } = this.state;
    return this.state.hasError ?
      <ErrorComponent error={error} error_info={error_info} resetErrorBoundary={() => { this.resetState(); }} /> :
      this.props.children;
  }
}

export default React.memo(ErrorBoundaryComponent);
